import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    src: String
  }

  connect() {
   let startTime = new Date().getTime();
    this.interval = setInterval(() => {
      if(new Date().getTime() - startTime > 300000){
        clearInterval(this.interval);
        return;
      }
      this.element.src = null;
      this.element.setAttribute('src', this.srcValue)
    }, 10000);
  }

  disconnect() {
    clearInterval(this.interval)
  }
}